var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/nam.phamanh/Documents/Nam/git/cs/lazada/node_modules/_nunjucks-loader@2.4.9@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/rar/list/slide-up.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div id=\"J_SlideUp\" class=\"alime-rar _block\">\n  ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "orders");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("order", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n    ";
frame = frame.push();
var t_7 = runtime.memberLookup((t_4),"packages");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("package", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n      <div class=\"alime-rar _package ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"last")) {
output += "last";
;
}
output += "\">\n        <div class=\"alime-rar _header\">\n          <h3>";
output += runtime.suppressValue(runtime.memberLookup((t_8),"title"), env.opts.autoescape);
output += "</h3>\n          <p>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "raNoText"), env.opts.autoescape);
output += ". ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"ra_no"), env.opts.autoescape);
output += "</p>\n          <p>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "requestedOnText"), env.opts.autoescape);
output += ": ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"request_time"), env.opts.autoescape);
output += "</p>\n        </div>\n        ";
frame = frame.push();
var t_11 = runtime.memberLookup((t_8),"items");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("item", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n          <div class=\"alime-rar _item\" data-package-no=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"ra_no"), env.opts.autoescape);
output += "\" data-item-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
output += "\">\n            <div class=\"alime-rar _info\">\n              <div class=\"alime-rar _photo\">\n                <section class=\"content\">\n                  <img src=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"image"), env.opts.autoescape);
output += "\" />\n                </section>\n              </div>\n              <div class=\"alime-rar _detail\">\n                <h2 class=\"_title\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"title"), env.opts.autoescape);
output += "</h2>\n                <p class=\"_desc\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"detail"), env.opts.autoescape);
output += "</p>\n                <p>";
output += runtime.suppressValue(runtime.memberLookup((t_12),"price"), env.opts.autoescape);
output += "</p>\n                <p>x ";
output += runtime.suppressValue(runtime.memberLookup((t_12),"quantity"), env.opts.autoescape);
output += "</p>\n                <label class=\"_status\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"status"), env.opts.autoescape);
output += "</label>\n              </div>\n            </div>\n            <div class=\"alime-rar _reason\">\n              ";
if(runtime.memberLookup((t_12),"return_reason")) {
output += "\n                <p class=\"alime-rar _reason-text\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "returnReasonText"), env.opts.autoescape);
output += ": <span>";
output += runtime.suppressValue(runtime.memberLookup((t_12),"return_reason"), env.opts.autoescape);
output += "</span></p>\n              ";
;
}
output += "\n              ";
if(runtime.memberLookup((t_12),"status_note")) {
output += "\n                <p class=\"alime-rar _status-note\"><i class=\"csc-icon icon-notification\"></i> ";
output += runtime.suppressValue(runtime.memberLookup((t_12),"status_note"), env.opts.autoescape);
output += "</p>\n              ";
;
}
output += "\n            </div>\n          </div>\n        ";
;
}
}
frame = frame.pop();
output += "\n      </div>\n    ";
;
}
}
frame = frame.pop();
output += "\n    <div class=\"alime-rar _footer\">\n      <div class=\"alime-rar _loading hidden\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "loadingText"), env.opts.autoescape);
output += "</div>\n    </div>\n  ";
;
}
}
frame = frame.pop();
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/rar/list/slide-up.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/app/extension/rar/list/slide-up.html
// module id = 390
// module chunks = 0 1